import React, { Fragment, useState } from "react";
import ReactEmoji from "react-emoji";

import CampaignChatLogo from "../Campaign/CampaignChatLogo";

const MentorChatMessageItem = ({
  user,
  profile,
  message,
  deleteMessage,
  deleteChatMessage,
  isAuthenticated,
  timeoutUser,
  unTimeoutUser,
}) => {
  const [showModal, setShowModal] = useState(false);

  const TimeOut = () => {
    timeoutUser(message.channelid);

    setTimeout(() => {
      unTimeoutUser(message.channelid);
    }, 30000);
  };

  return (
    <Fragment>
      <div className="chat-body">
        <div className="chat-container">
          <div className="chat-user-container">
            <div className="chat-item-containers">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.avatar}`}
                className="chat-avi"
                alt="chatimage"
              />
            </div>
            <div className="chat-item-containers">
              <div className="chat-text">
                <span className="red mr-5 chat-logo-align">
                  {message.firstname === "imeBOT" ? (
                    <i className="fa-solid fa-robot chat-logo"></i>
                  ) : (
                    <CampaignChatLogo />
                  )}
                  {user.channelid === message.channelid && isAuthenticated && (
                    <i class="fa-solid fa-crown fa-sm gold mx-3"></i>
                  )}
                  <span className="change-name-color">
                    {message.firstname}{" "}
                    {message.lastname !== "Fields" ? message.lastname : ""}:
                    {"\n"}
                  </span>{" "}
                </span>
                {message.gif !== "" && (
                  <img src={message.gif} alt="avatar" className="gif-image" />
                )}
                <span
                  className={`${
                    message.text !== "Message Deleted..."
                      ? "max-text-width"
                      : "italicized red"
                  } 
                  `}
                >
                  {ReactEmoji.emojify(message.text)}
                </span>
              </div>
            </div>
          </div>
          {message.firstname !== "imeBOT" &&
            message.text !== "Message Deleted..." &&
            !showModal && (
              <div className="chat-item-modal-containers">
                <div className="chat-user-info">
                  <i
                    onClick={() => {
                      if (showModal) {
                        setShowModal(false);
                      } else {
                        setShowModal(true);
                      }
                    }}
                    className="fas fa-ellipsis-v mx-10 red cursor"
                  ></i>
                </div>
              </div>
            )}
        </div>
        <div className="center">
          {message.firstname !== "imeBOT" &&
            !message.deleted &&
            showModal &&
            isAuthenticated && (
              <div className="chat-item-modal-containers">
                <div className="chat-user-info">
                  <i
                    onClick={() => {
                      if (showModal) {
                        setShowModal(false);
                      } else {
                        setShowModal(true);
                      }
                    }}
                    className="fas fa-ellipsis-v mx-10 red cursor"
                  ></i>
                </div>
                <div className="chat-modal">
                  <ul className="modal-items">
                    {user.channelid === profile.channelid && showModal && (
                      <li
                        onClick={() => {
                          TimeOut();
                          deleteChatMessage(message.messageid, message);
                        }}
                        className="modal-item"
                      >
                        <i className="fa-solid fa-hourglass-half mx-5 white"></i>
                        Timeout
                      </li>
                    )}
                    {message.channelid === user.channelid &&
                      user.channelid !== "roland" &&
                      showModal && (
                        <li
                          onClick={() =>
                            deleteChatMessage(message.messageid, message)
                          }
                          className="modal-item"
                        >
                          <i className="fas fa-times mx-5 white"></i>
                          Delete
                        </li>
                      )}
                    {message.channelid !== user.channelid &&
                      user.channelid === "roland" &&
                      showModal && (
                        <li
                          onClick={() =>
                            deleteChatMessage(message.messageid, message)
                          }
                          className="modal-item"
                        >
                          <i className="fas fa-times mx-5 white"></i>
                          Delete
                        </li>
                      )}
                    {message.channelid !== user.channelid && showModal && (
                      <li className="modal-item">
                        <i className="fas fa-flag mx-5 white"></i>
                        Report
                      </li>
                    )}
                    {user.channelid === "roland" &&
                      user.channelid !== message.channelid &&
                      showModal && (
                        <li className="modal-item">
                          <i className="fas fa-ban mx-5 white"></i>
                          Ban
                        </li>
                      )}
                  </ul>
                </div>
              </div>
            )}
        </div>
      </div>
    </Fragment>
  );
};

export default MentorChatMessageItem;
